import React from 'react';

import Info from './InfoComponent';
import ContactUs from './ContactUsComponent';

function HomePage() {
  return (
    <div className='homePageComponent'>
      <Info />
      <ContactUs />
    </div>
  );
}

export default HomePage;
